import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginControllerService } from './app-services/apiLoginAppController';
import { AppState } from '~core/states/app/app.state';


@Injectable({
  providedIn: 'root'
})
export class SAMLDataService {
  private appState = inject(AppState);
  private http = inject(HttpClient);
  private loginSvc = inject(LoginControllerService);
  private toastr = inject(ToastrService);


  getSettings(): Observable<any> {
    return this.http.get<any>(`saml/idpgetsettings`);
  }

  samlLogin(samlResponse: string): Observable<any> {
    const params = {
      samlResponse
    };
    return this.http.post<string>(`saml/samllogin`, params);
  }

  ssoLogin(connectionStringName: string, facilityId: number, samlToken: string): Observable<any> {
    console.debug('Login call started...');
    return this.loginSvc.ssoLogin(connectionStringName, facilityId, samlToken)
      .pipe(
        catchError(error => {
          console.error(`Login Error: ${error?.message}`);
          this.toastr.error('Authorization Failed');
          return of(false);
        })
      );
  }
}
